import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA
} from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { AppService,InstructionService, DialogService, StateService } from '../../../../../services'
import * as moment from 'moment'
const KEY = 'intruction-actions-dialog'



@Component({
	selector: 'atyl-intrction-historique-dialog',
	templateUrl: './instruction-historique-dialog.component.html',
	styleUrls: ['./instruction-historique-dialog.component.scss'],
})
@Stringable({
	path: 'views/partials/content/actions/instruction-historique-dialog',
	key: KEY
})
export class InstructionHistoriqueDialog extends BaseDialogComponent implements OnInit {
	loading: boolean = false;
	
   
    instruction: any;
    dossier: any;
    
    historique:any[]=[];
    loadingHistorique:boolean=true;
  
	@StringableValues(KEY) strings: any
	
	now:any=new Date();
	
	title: any
	
    errors:any =[]
    errorMessage:string ="";
    
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<InstructionHistoriqueDialog>,
		public dialog: MatDialog,
		private stateService: StateService,
	   private instructionService:	InstructionService,
		private appService: AppService,
		dialogService: DialogService

	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
        this.title=this.strings.title;
        
        this.loadingHistorique=true;
		if (this.data) {
			
			
			  
		   if (this.data.dossier!=undefined && this.data.dossier)
	              this.dossier=this.data.dossier;
	              
	       if (this.data.instruction!=undefined && this.data.instruction) { 
			   this.instruction = this.data.instruction;
			   console.log("ngOnInit",this.instruction)
			   if (this.instruction.type)
			    	this.title+=": "+this.instruction.type.libelle;
			   if (this.instruction.demande)
			    	this.title+="("+this.instruction.demande.type.libelle+")";
			   
			 	this.instructionService.historique( this.instruction.ID).subscribe((res: JSONRpcResponse) => {
	                    this.historique = res.result;
	                 
	                    this.loadingHistorique=false;
	                    this.changeDetectorRef.detectChanges();
	                }
	                
	                
	            );
			}
		}
		
	}
	
	 
	 
	
}
